import { Target, Wallet, TrendingUp, Anchor, Route, FileWarning } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead, FeatureCard } from "@/components/site/Primitives";

const DOMAINS = [
  { icon: Target, tint: "gold", title: "Strategic Decisions", copy: "Enterprise priorities, commercial exposure and long-term value creation.", examples: ["Portfolio priorities", "Strategic scenarios", "Executive visibility"] },
  { icon: Wallet, tint: "gold", title: "Financial Decisions", copy: "Commercial exposure, financial impact and capital allocation.", examples: ["Exposure quantification", "Financial scenarios", "Capital efficiency"] },
  { icon: TrendingUp, tint: "blue", title: "Commercial Decisions", copy: "Portfolio performance, margin protection and commercial opportunity.", examples: ["Margin priorities", "Market opportunities", "Negotiation focus"] },
  { icon: Anchor, tint: "blue", title: "Chartering Decisions", copy: "Fixture strategy, charter exposure and market alternatives.", examples: ["Charter exposure", "Counterparty context", "Market options"] },
  { icon: Route, tint: "blue", title: "Operational Decisions", copy: "Operational disruption, commercial impact and execution dependencies.", examples: ["Delay implications", "Affected assets", "Execution priorities"] },
  { icon: FileWarning, tint: "purple", title: "Contract, Claims & Risk Decisions", copy: "Contract obligations, claims exposure, compliance and escalation.", examples: ["Contract interpretation", "Claims exposure", "Risk escalation"] },
];

export function Value() {
  return (
    <SectionShell id="value" tone="mist">
      <div className="max-w-3xl">
        <SectionHead
          label="Executive Value"
          labelColor="gold"
          title="Better-aligned decisions across the enterprise."
          intro="One connected commercial-intelligence platform supports the full range of maritime commercial decisions—across strategy, finance, commercial, chartering, operations and risk."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {DOMAINS.map((d, i) => (
          <Reveal key={d.title} delay={(i % 3) * 0.07}>
            <FeatureCard icon={d.icon} tint={d.tint} title={d.title} examples={d.examples}>
              {d.copy}
            </FeatureCard>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <p className="mt-12 max-w-[56ch] text-base leading-relaxed text-natsu-slate">
          Designed to support faster, clearer and financially better-informed
          decisions.
        </p>
      </Reveal>
    </SectionShell>
  );
}
